import type { StyleModelImagesKind } from "../../types.ts";

export const ModelTypeDisplay: Record<StyleModelImagesKind, string> = {
  PHOTOGRAPHY: "Photography",
  ILLUSTRATION_2D: "2D Illustration",
  GRAPHIC_3D: "3D Graphic",
  ICON: "Icon",
  OTHER: "Other",
} as const;
